/**
 * EZ FAQ master nav: long-form sidebar + L2 jump bar (active section, TOC toggle).
 */
(function () {
  function initFaqNav(root) {
    const tocToggle = root.querySelector('[data-ez-faq-toc-toggle]');
    const tocPanel = root.querySelector('[data-ez-faq-toc-panel]');
    const navLinks = root.querySelectorAll('[data-ez-faq-rail-link], .ez-faq__jump-link');
    const groupAnchors = root.querySelectorAll('[data-ez-faq-group], .ez-faq__group[id^="faq-"]');

    if (tocToggle && tocPanel) {
      tocToggle.addEventListener('click', function () {
        const open = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', open ? 'false' : 'true');
        tocPanel.classList.toggle('is-collapsed', open);
      });
    }

    function setActiveNav(handle) {
      navLinks.forEach((link) => {
        const href = link.getAttribute('href') || '';
        const isActive = Boolean(handle && href === '#' + handle);
        link.classList.toggle('is-active', isActive);
      });
    }

    function handleFromHash() {
      const hash = window.location.hash.replace(/^#/, '');
      if (!hash) return;
      if (hash.indexOf('faq-') === 0) {
        setActiveNav(hash);
      }
    }

    handleFromHash();
    window.addEventListener('hashchange', handleFromHash);

    if (!groupAnchors.length || !navLinks.length) return;

    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (visible.length) {
          const handle = visible[0].target.getAttribute('id');
          if (handle) setActiveNav(handle);
        }
      },
      { rootMargin: '-20% 0px -55% 0px', threshold: [0, 0.15, 0.5] }
    );

    groupAnchors.forEach((el) => observer.observe(el));
  }

  function boot() {
    const roots = new Set();
    document.querySelectorAll('[data-ez-faq-longform]').forEach((el) => roots.add(el));
    document.querySelectorAll('.ez-faq__jump-bar').forEach((bar) => {
      const root = bar.closest('.ez-faq');
      if (root) roots.add(root);
    });
    roots.forEach(initFaqNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
